<template>
  <div class="skeleton-loader">
    <!-- Mountain / bar chart animation -->
    <div class="lf-peaks">
      <div class="lf-peak-wrap p1">
        <div class="lf-peak-track">
          <div class="lf-peak-fill"></div>
        </div>
      </div>
      <div class="lf-peak-wrap p2">
        <div class="lf-peak-track">
          <div class="lf-peak-fill"></div>
        </div>
      </div>
      <div class="lf-peak-wrap p3">
        <div class="lf-peak-track">
          <div class="lf-peak-fill"></div>
        </div>
      </div>
    </div>

    <!-- Wordmark -->
    <div class="lf-wordmark">
      <span class="lucky">Lucky</span><span class="friday"> Friday</span>
    </div>

    <!-- Loading message passed in via prop -->
    <div class="lf-msg">{{ loadingText }}</div>

    <!-- Dot indicators in sync with bars -->
    <div class="lf-dots">
      <div class="lf-dot d1"></div>
      <div class="lf-dot d2"></div>
      <div class="lf-dot d3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    loadingText: {
      type: String,
      default: 'Loading...',
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');

.skeleton-loader {
  position: fixed;
  inset: 0;
  background: #004751;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  z-index: 9999;
}

.lf-peaks {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  height: 64px;
}

.lf-peak-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 64px;
}

.lf-peak-track {
  width: 18px;
  border-radius: 5px 5px 3px 3px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.07);
}

.lf-peak-fill {
  width: 100%;
  border-radius: 5px 5px 3px 3px;
  transform-origin: bottom;
  transform: scaleY(0);
}

/* Peak 1 — left, medium (40px), teal, delay 0s */
.p1 .lf-peak-track {
  height: 40px;
}
.p1 .lf-peak-fill {
  height: 100%;
  background: #48ffcd;
  animation: riseBar 1.8s cubic-bezier(0.4, 0, 0.2, 1) 0s infinite;
}

/* Peak 2 — center, tallest (64px), white, delay 0.18s */
.p2 .lf-peak-track {
  height: 64px;
  width: 22px;
}
.p2 .lf-peak-fill {
  height: 100%;
  background: #ffffff;
  animation: riseBar 1.8s cubic-bezier(0.4, 0, 0.2, 1) 0.18s infinite;
}

/* Peak 3 — right, medium-short (48px), teal, delay 0.36s */
.p3 .lf-peak-track {
  height: 48px;
}
.p3 .lf-peak-fill {
  height: 100%;
  background: #48ffcd;
  animation: riseBar 1.8s cubic-bezier(0.4, 0, 0.2, 1) 0.36s infinite;
}

@keyframes riseBar {
  0% {
    transform: scaleY(0);
    opacity: 0.3;
  }
  35% {
    transform: scaleY(1);
    opacity: 1;
  }
  70% {
    transform: scaleY(1);
    opacity: 1;
  }
  90% {
    transform: scaleY(0.08);
    opacity: 0.2;
  }
  100% {
    transform: scaleY(0);
    opacity: 0.3;
  }
}

.lf-wordmark {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-top: 20px;
  margin-bottom: 8px;
}

.lucky {
  color: #48ffcd;
}
.friday {
  color: rgba(255, 255, 255, 0.55);
}

.lf-msg {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
  opacity: 0;
  animation: fadeInMsg 0.4s ease 0.6s forwards;
}

@keyframes fadeInMsg {
  to {
    opacity: 1;
  }
}

.lf-dots {
  display: flex;
  gap: 5px;
  margin-top: 24px;
}

.lf-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(72, 255, 205, 0.4);
  animation: dotPulse 1.8s ease infinite;
}

.d1 {
  animation-delay: 0s;
}
.d2 {
  animation-delay: 0.18s;
}
.d3 {
  animation-delay: 0.36s;
}

@keyframes dotPulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  35% {
    opacity: 1;
    transform: scale(1.2);
  }
  70% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>

<!-- <template>
  <div class="skeleton-loader">
    <div class="load-wrapp">
      <div class="load-2">
        <p>{{ loadingMessage }}</p>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loadingText: {
      type: String,
      default: 'Loading...',
    },
  },
  setup(props) {
    let loadingMessage = props.loadingText;

    return {
      loadingMessage,
    };
  },
};
</script>

<style scoped>
body {
  margin: 0 auto;
  padding: 20px;
  max-width: 1200px;
  overflow-y: scroll;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  color: #777;
  background-color: #f7f7f7;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

.content {
  padding: 15px;
  /* overflow: hidden; */
  background-color: #e7e7e7;
  background-color: rgba(0, 0, 0, 0.06);
}

.clear {
  clear: both;
}

.load-wrapp {
  height: 600px;
  text-align: center;
  padding: 0 1em 1em 1em;
  margin-top: 60px;
}

.line {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 15px;
}

.light-theme .line {
  background: #004751;
}

.dark-theme .line {
  background: #48ffcd;
}

.load-2 .line:nth-last-child(1) {
  animation: loadingB 1.5s 1s infinite;
}
.load-2 .line:nth-last-child(2) {
  animation: loadingB 1.5s 0.5s infinite;
}
.load-2 .line:nth-last-child(3) {
  animation: loadingB 1.5s 0s infinite;
}

@keyframes loadingB {
  0% {
    width: 25px;
  }
  50% {
    width: 45px;
  }
  100% {
    width: 25px;
  }
}

.skeleton-loader {
  width: 100%;
  animation: pulse 1s infinite ease-in-out;
}
</style> -->
